import React from "react";
import { useState, useEffect } from "react";
import loader from "../assets/images/loader.gif";
import document from "../assets/images/document-no-found.svg";
import DocPlaceholder from '../assets/images/document-placeholder.jpg';
import { Card, Row, Col } from 'react-bootstrap';
import "./Quote.scss"
import WebService from "../utility/WebService";
import Loader from "../Loader/Loader";
import HelperService from "../utility/HelperService";
import PreviewBlade from "./PreviewBlade";
import videoPlaceholder from '../assets/images/videoPlaceholder.png'
import { PlayFill } from "react-bootstrap-icons";
import PdfIcon from '../assets/images/pdf.png';
import XlsIcon from '../assets/images/xls.png';
import DocIcon from '../assets/images/doc.png';
import { Button } from "../Button/Button";

interface propData {
  data: any
}

const QuoteDetailMedia = (props: propData) => {
  const [ShowLoader, setShowLoader] = useState(false);
  const [documentData, setDocumentData] = useState<any[]>([])
  const [isLoading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false)
  const [selectedMedia, setSelectedMedia] = useState<any>()

  useEffect(() => {
    if (props.data && props.data.length > 0) {
      setDocumentData(props.data)
    } else {
      setDocumentData([])
    }
  }, [props.data]);

  const getDocuments = () => {
    setShowLoader(true);
    WebService.getAPI({
      action:
        "EntityDocument/GetQuoteDocuments/" +
        340 + "/" + 1 + "/" + 1104,
      body: null,
    })
      .then((res: any) => {
        setShowLoader(false)
        setDocumentData(res.Data)
      })
      .catch(() => {
        setShowLoader(false);
      });
  };

  const onCloseModal = () => {
    setShowModal(false)
  }

  const downloadAll = () => {
    for (var i in documentData) {
      window.open(documentData[i]?.webReference)
    }
  }

  return <>
    <PreviewBlade
      isShow={showModal}
      isClose={onCloseModal}
      data={documentData}
      selectedData={selectedMedia}
    />
    <Loader show={isLoading} />
    <div className=''>
      <Card className="card-style form-style invoice-call-picture-card" style={{ marginBottom: 50 }}>
        <Card.Body className=" ">
          <div className="mt-1 add-document">
            {
              ShowLoader == true ?
                <div style={{ textAlign: "center" }}>
                  <img
                    style={{ position: "relative" }}
                    src={loader}
                    alt="No loader found"
                  />
                  <div style={{ position: "relative", color: "white" }}>
                    Loading...
                  </div>
                </div>
                :
                <Row className='justify-content-center'>
                  {
                    documentData.length == 0 ?
                      <Col md={6}>
                        <div className='text-center'>
                          <img src={document} alt="" width={70} className="mb-3 " />
                          <p className='font-w-medium text-dark'>Documents aren’t uploaded.</p>
                        </div>
                      </Col>
                      :
                      <div className="">
                        {documentData.length > 0 && <div className="download-all-button">
                          <div className="download-buttons" onClick={() => downloadAll()} style={{ visibility: 'hidden' }}>
                            Download All
                          </div>
                        </div>}
                        <div className="">
                          <Row>
                            {
                              documentData.length > 0 && documentData.map((item: any, index: number) => {
                                return (
                                  <Col key={item.seqNum || index} xl={2} lg={2} sm={3} md={4}>
                                    <div className="img-box-view" onClick={() => {
                                      if (item.fileType == 'IMAGE' || item.fileType == 'VIDEO') {
                                        setSelectedMedia(index)
                                        setShowModal(true)
                                      } else {
                                        window.open(item.webReference)
                                      }
                                    }}>
                                      <div className="document-image-div">
                                        <div className="img-wrap">
                                          {
                                            item.fileType == 'IMAGE' &&
                                            <img src={item.webReferenceThumb ? item.webReferenceThumb : item.webReference ? item.webReference : DocPlaceholder} alt="imag" className="image cursor-pointer" />
                                          }
                                          {
                                            item.fileType == 'PDF' &&
                                            <div className="image">
                                              <img src={PdfIcon} alt="imag" className="cursor-pointer" style={{ paddingTop: 10, objectFit: 'contain', paddingBottom: 10, height: 130 }} />
                                            </div>
                                          }
                                          {
                                            item.fileType == 'DOC' &&
                                            <div className="image">
                                              <img src={DocIcon} alt="imag" className="cursor-pointer" style={{ paddingTop: 10, objectFit: 'contain', paddingBottom: 10, height: 130 }} />
                                            </div>
                                          }
                                          {
                                            item.fileType == 'XLS' &&
                                            <div className="image">
                                              <img src={XlsIcon} alt="imag" className="cursor-pointer" style={{ paddingTop: 10, objectFit: 'contain', paddingBottom: 10, height: 130 }} />
                                            </div>
                                          }
                                          {
                                            item.fileType == 'VIDEO' &&
                                            <div className="video-img">
                                              <img src={item.webReferenceThumb ? item.webReferenceThumb : DocPlaceholder} alt="imag" className="image cursor-pointer" style={{ width: '100%', height: 150, }} />
                                              <PlayFill className="play-icon" size={60} color="#ffffff" />
                                            </div>
                                          }
                                          {/* {
                                            item.fileType == 'IMAGE' &&
                                            <img src={item.mediaFileURL ? item.fileType == 'IMAGE' ? item.mediaFileURL : videoPlaceholder : DocPlaceholder} alt="imag" className="image cursor-pointer" />
                                          } */}
                                        </div>
                                      </div>
                                      <div className="img-descrp text-truncate ">{(item.docShortDesc)}</div>
                                      <div className=" ">
                                        <div className="font-14">{item.insertedBy}</div>
                                        <div className="username text-truncate">{item.insertedOn}</div>
                                        <div className="date text-truncate">{HelperService.getFormatedDateAndTime(item.uploadedOnUTC)}</div>
                                      </div>
                                    </div>
                                  </Col>
                                )
                              })
                            }
                          </Row>
                        </div>
                      </div>
                  }
                </Row>
            }
          </div>
        </Card.Body>
      </Card>
    </div>


  </>;
};

export default QuoteDetailMedia;


